import videojs from 'video.js';
import './button-group-component.js';

class ButtonGroup extends videojs.getPlugin('plugin') {
  constructor(player, options) {
    super(player, options);
    player.on('ready', () => {
      player.addClass('vjs-button-group');
      player.addChild('ButtonGroupComponent');
    });
  }
}

videojs.registerPlugin('buttonGroup', ButtonGroup);
